export default function fetchWithTimestamp(url, init = {}) {
  const timestamp = `_=${Date.now()}`;
  const separator = url.includes("?") ? "&" : "?";
  const urlWithTimestamp = `${url}${separator}${timestamp}`;

  return fetch(urlWithTimestamp, init);
}
